// extracted by mini-css-extract-plugin
export default {"center":"style_center__6vIuU","wave":"style_wave__V1ZHj","wave-light":"style_wave-light__+vB+2","wave-dark":"style_wave-dark__X4Das"};